import { Menu } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";

const HorizontalNav = ({ selected }) => {
  const [activeLink, setActiveLink] = useState("analytics");
  const handleLinkClick = (key) => {
    setActiveLink(key);
    selected(key);
  };

  return (
    <div className="py-2 px-2">
      <Menu
        mode="horizontal"
        className="bg-boxGrey h-5.4 rounded-lg w-35.6 border-none"
      >
        <div className="bg-boxGrey rounded-lg">
          <Menu.Item
            key="analytics"
            className={`h-5.4 w-17.8 custom-tab-style rounded-lg p-0.4 ${
              activeLink === "analytics"
                ? "!bg-white !text-black"
                : "!text-grey !bg-boxGrey"
            } `}
            onClick={() => handleLinkClick("analytics")}
          >
            <Link to="">Analytics</Link>
          </Menu.Item>
          <Menu.Item
            key="services"
            className={`h-5.4 w-17.8 custom-tab-style rounded-lg p-0.4 ${
              activeLink === "services"
                ? "!bg-white !text-black"
                : "!text-grey !bg-boxGrey"
            }`}
            onClick={() => handleLinkClick("services")}
          >
            <Link to="">Services</Link>
          </Menu.Item>
        </div>
      </Menu>
    </div>
  );
};

export default HorizontalNav;
